/** Shared Visit / Polycam bridge helpers (no React). */

export function isPolycamHost(url) {
  try {
    const host = new URL(String(url || "").trim()).hostname.toLowerCase();
    return (
      host === "poly.cam" ||
      host.endsWith(".poly.cam") ||
      host === "polycam.com" ||
      host.endsWith(".polycam.com")
    );
  } catch {
    return false;
  }
}

export function isSplatFileUrl(url) {
  const u = String(url || "").trim().toLowerCase();
  if (!u) return false;
  const path = u.split("?")[0].split("#")[0];
  return (
    /\.(splat|ply|spz|sog|ksplat)$/.test(path) ||
    (path.endsWith("meta.json") && path.includes("/visits/")) ||
    path.includes("/splats/")
  );
}

export function visitFromShareUrl(url) {
  const u = String(url || "").trim();
  if (!u) return null;
  if (isSplatFileUrl(u)) return { type: "file", file_url: u };
  return { type: "url", embed_url: u };
}

/**
 * Desk badge for a property_visits row / share visit.
 * Polycam URLs are a bridge (XFO DENY — not an iframe embed).
 */
export function visitKindLabel(visit) {
  if (!visit || typeof visit !== "object") return "Visit";
  const type = String(visit.type || "").toLowerCase();
  if (type === "file" || isSplatFileUrl(visit.file_url || visit.embed_url || "")) {
    return "Gaussian Splat";
  }
  const url = visit.embed_url || visit.file_url || "";
  if (isPolycamHost(url)) return "Polycam bridge";
  if (type === "url" || /^https?:\/\//i.test(String(url))) return "Hosted link";
  return "Visit";
}

/**
 * Visit for client share / listing site payloads. When the API names the
 * property_visits row (visit_id), the shared viewer loads the room manifest
 * (multi-room streaming, password gate). Otherwise a bare URL as before.
 */
export function visitFromSharePayload(data) {
  if (!data || typeof data !== "object") return null;
  const url = String(data.visit_url || "").trim();
  const id = String(data.visit_id || "").trim();
  const isFile =
    String(data.visit_type || "").toLowerCase() === "file" ||
    Boolean(data.visit_protected) ||
    (url && isSplatFileUrl(url));
  if (id && isFile) return { type: "file", id, file_url: url || null };
  return url ? visitFromShareUrl(url) : null;
}
